export enum ActionTypes {
  GetNextInvoice = 'getNextInvoice',
  GetNextInvoiceSuccess = 'getNextInvoice.success',
  GetNextInvoiceFailure = 'getNextInvoice.failure',
}
